import React from "react";
import { pluralize } from "@common/helpers/string";
import { CounterpartiesWithEmptyValue } from "../AggregatedFilters/CounterpartyFilter/lib";

interface Props {
    filters: {
        counterpartiesIds?: string[];
        withEmptyOrUnverifiedCounterparty?: boolean;
        hasCounterparty?: boolean;
    };
    counterparties?: CounterpartiesWithEmptyValue;
    /**
     * Word used to describe a single counterparty in the fallback/plural
     * label text (e.g. "customer" on Invoices, "vendor" on Bills). Defaults
     * to the generic "counterparty".
     */
    entityLabel?: string;
}

export const CounterpartiesFilterLabel: React.FC<Props> = ({
    filters: {
        counterpartiesIds,
        withEmptyOrUnverifiedCounterparty,
        hasCounterparty,
    },
    counterparties,
    entityLabel = "counterparty",
}) => {
    // The passed-in label may be Title Case (used for the filter tab title,
    // e.g. "Customer"/"Vendor") — lowercase it for use mid-sentence here.
    const lowerCaseEntityLabel = entityLabel.toLowerCase();

    if (counterpartiesIds) {
        if (counterpartiesIds.length === 1) {
            const counterparty = counterparties?.find(
                (c) => c.counterparty?.id === counterpartiesIds[0],
            );
            if (counterparty) {
                return <>{counterparty.counterparty?.name}</>;
            }
        }

        return (
            <>
                {counterpartiesIds.length}{" "}
                {pluralize(
                    lowerCaseEntityLabel,
                    counterpartiesIds?.length ?? 0,
                )}
            </>
        );
    }

    if (hasCounterparty) {
        return <>Has {lowerCaseEntityLabel}</>;
    }

    if (withEmptyOrUnverifiedCounterparty) {
        return <>No {lowerCaseEntityLabel}</>;
    }

    return null;
};
